var ClientPlatform;

(function (ClientPlatform) {
  ClientPlatform["Web"] = "web";
})(ClientPlatform || (ClientPlatform = {}));

export default ClientPlatform;